export const proofOfPerformanceReportSelector = state => state.entities.proofOfPerformanceReports;
